import React, { useEffect } from "react";
import { Modal } from "react-bootstrap";
import { closeIcon } from "../../../../assets/svg";
import "../../../../styles/modal/profile-modal/profile.scss";
import { profileImage } from "../../../../assets/png";
// import api from "../../../../api";

interface profileModal {
  open: boolean;
  userData?: any;
  setOpen: (target: boolean) => void;
}

const ProfileModal = ({ open, userData = {}, setOpen }: profileModal) => {
  const [trainers, setTrainers] = React.useState<any[]>([]);
  const [loadingTrainers, setLoadingTrainers] = React.useState<boolean>(false);
  const onClose = () => {
    setOpen(false);
  };
  useEffect(() => {
    if (userData?.userId) {
      setLoadingTrainers(true);
      // api
      //   .get("/api/user/v1/user/trainer", {
      //     headers: { "x-user-id": userData?.userId },
      //   })
      //   .then((res) => {
      //     setTrainers(res.data.trainers);
      //     setLoadingTrainers(false);
      //   })
      //   .catch((e) => setLoadingTrainers(false));
    }
  }, [userData?.userId]);

  return (
    <Modal
      show={open}
      //   centered={windowView === SCREEN_TYPE.MD_VIEW}
      className="custom-modal-profile"
      centered
    >
      <Modal.Header>
        <Modal.Title className="d-flex flex-direction-column">
          <div className="heading-left">
            <img src={profileImage} alt="profile" />
            <span className="name">{userData?.name}</span>
            {/* <span className="email">{data?.email}</span> */}
          </div>

          <div className="heading-right">
            <div className="planType">{userData?.gabit}</div>
            <div className="program-name">{userData?.healthGoal}</div>
            {/* <div className="desc">{data?.description}</div> */}
            <div>
              <span>Expires:</span>
              <span>{userData?.expireBy}</span>
            </div>
          </div>

          <div onClick={onClose} className="crossIcon">
            <img src={closeIcon} alt="close-icon" />
          </div>
        </Modal.Title>
      </Modal.Header>

      <Modal.Body></Modal.Body>
      <Modal.Body>
        <div className="heading">Trainers</div>
        {loadingTrainers ? <div>Loading...</div> : null}
        {trainers.map((trainer) => (
          <SingleTrainer trainer={trainer} />
        ))}
        {/* {data?.combinedArray.length > 0 &&
          data.combinedArray.map((item, index) => (
            <span key={index}>{item?.session}</span>
          ))} */}
      </Modal.Body>
    </Modal>
  );
};

const SingleTrainer = ({ trainer }: any) => (
  <div key={trainer?.trainerId && trainer?.cohortName} style={{ padding: 10 }}>
    <div>Name: {trainer?.trainerName}</div>
    <div>Verticle: {trainer?.verticle}</div>
    <div>Cohort: {trainer?.cohortName}</div>
  </div>
);

export default ProfileModal;
